import { chartConfigs } from '../utils/constants';

export default function ChartNotes({ chartType, range }) {
  const renderNote = () => {
    if (chartType === 'keyAssets') {
      return (
        <div style={{
          marginTop: '0px',
          fontSize: '12px',
          color: '#6b7280',
          textAlign: 'left'
        }}>
          備註：原油為每桶價格，黃金已轉換為每克價格，比特幣已轉換為每毫比特幣價格，英偉達、台積電、阿斯麥股價被縮放10倍。使用上方日期輸入框自由設置時間範圍。
        </div>
      );
    }

    if (chartType === "usJobs" && range === 365*100+31) {
      return (
        <div style={{
          marginTop: '24px',
          fontSize: '12px',
          color: '#6b7280',
          textAlign: 'left'
        }}>
          備註：大非農年度取均值聚合（單位：千人），小非農年度累加聚合（單位：人）。
        </div>
      );
    }

    if (chartType === "usDebt" && range > 365*5+31) {
      return (
        <div style={{
          marginTop: '24px',
          fontSize: '12px',
          color: '#6b7280',
          textAlign: 'left'
        }}>
          備註：全部數據按月取最後日期數值聚合。
        </div>
      );
    }

    if (["dualLine", "dualLinePlus"].includes(chartConfigs[chartType]?.type) && range > 365*10) {
      return (
        <div style={{
          marginTop: '24px',
          fontSize: '12px',
          color: '#6b7280',
          textAlign: 'left'
        }}>
          備註：全部數據已經按月度取均值聚合。
        </div>
      );
    }

    if (chartType === 'forex') {
      return (
        <div style={{
          marginTop: '24px',
          fontSize: '12px',
          color: '#6b7280',
          textAlign: 'left'
        }}>
        備註：新台幣(TWD) 人民幣(CNY) 日元(JPY) 歐元(EUR) 英鎊(GBP) 墨西哥比索(MXN) 巴西雷亞爾(BRL) 印度盧比(INR) 瑞士法郎(CHF) 加幣(CAD) 澳元(AUD) 韓圜(KRW) 瑞典克朗(SEK) 泰銖(THB)
        </div>
      );
    }
    if (chartType === "usGDP" && range !== 365*100+31) {
      return (
        <div style={{
          marginTop: '24px',
          fontSize: '12px',
          color: '#6b7280',
          textAlign: 'left'
        }}>
          備註：計算公式 GDP = C + I + G + (X - M) 其中C為消費、I為投資、G為政府開支、X為出口、M為進口
        </div>
      );
    }
    return null;
  };

  return renderNote();
}